import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginError from '@/views/LoginError'
import PermissionDenied from '@/views/PermissionDenied'
import CreateOrUpdateCredential from '@/views/credentials/CreateOrUpdateCredential'
import CredentialCertificates from '@/views/credentials/CredentialCertificates'
import Credentials from '@/views/credentials/Credentials'
import CredentialsAdmin from '@/views/credentials/CredentialsAdmin'
import Dashboard from '@/views/dashboard/Dashboard'
import AddDevice from '@/views/devices/AddDevice'
import Devices from '@/views/devices/Devices'
import UpdateDevice from '@/views/devices/UpdateDevice'
import License from '@/views/license/License'
import CreateOrUpdateUser from '@/views/users/CreateOrUpdateUser'
import UserProfile from '@/views/users/UserProfile'
import Users from '@/views/users/Users'
import Welcome from '@/views/welcome/Welcome'

import Role from '../Role'
import rdssUtil from '../services/api/rdssUtil'
import users from '../services/api/users'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/',
    redirect: 'Dashboard'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      allowedRoles: [Role.ADMIN, Role.USER]
    },
    beforeEnter(to, from, next) {
      if (store.state.remoteConfig.rdssPublicUrl) {
        // console.log('redirecing to DashboardRDSS')
        next({ name: 'DashboardRDSS' })
      } else next()
    }
  },
  {
    path: '/dashboardRDSS',
    name: 'DashboardRDSS',
    component: Dashboard,
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        try {
          await rdssUtil.joinUserOnRdss()
        } catch (error) {
          console.log('Cant join rdds user')
        }
        const rdssPublicUrl = store.state.remoteConfig?.rdssPublicUrl ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'dashboard'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/dashboardRSSP',
    name: 'DashboardRSSP',
    component: Dashboard,
    meta: {
      allowedRoles: [Role.ADMIN, Role.USER]
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    async  beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/list'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/allDocuments',
    name: 'AllDocuments',
    async    beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/administrator/list'
      }
    },
    meta: {
      allowedRoles: [Role.ADMIN],
      layout: 'blank'
    }
  },
  {
    path: '/recycleBinDocuments',
    name: 'RecycleBinDocuments',
    async  beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureChains/administrator/recycleBin'
      }
    },
    meta: {
      allowedRoles: [Role.ADMIN],
      layout: 'blank'
    }
  },
  {
    path: '/signatureProfiles',
    name: 'SignatureProfiles',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signatureProfiles'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      allowedRoles: [Role.ADMIN]
    },
    children: [
      {
        path: '/users/add',
        name: 'CreateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: {
          allowedRoles: [Role.ADMIN]
        }
      },
      {
        path: '/users/:userId/update',
        name: 'UpdateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: {
          allowedRoles: [Role.ADMIN]
        }
      }
    ]
  },
  {
    path: '/users-rdss',
    name: 'Users RDSS',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'users'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/user/profilerdss',
    name: 'UserProfileRDSS',
    beforeEnter() {
      const rdssPublicUrl = store.state.config !== null ? store.state.remoteConfig.rdssPublicUrl : ''
      location.href = rdssPublicUrl + 'user/profile'
    },
    meta: {
      layout: 'blank'
    }
  },
  /* {
    path: '/credentialsAdmin',
    name: 'CredentialsAdmin',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'credentialsAdmin'
      }
    },
    meta: {
      layout: 'blank'
    }
  }, */
  {
    path: '/credentialsAdmin',
    name: 'CredentialsAdmin',
    component: CredentialsAdmin,
    meta: {
      allowedRoles: [Role.ADMIN]
    }
  },
  {
    path: '/importedCredentials',
    name: 'credentialsAdminImportedCredentials',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'importedCredentials'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/importedEvroTrustCredentials',
    name: 'CredentialsEvroAdmin',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'importedEvroTrustCredentials'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/credentialsRDSS',
    name: 'credentialsRDSS',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'credentials'
      }
    },
    meta: {
      layout: 'blank'
    }
  },

  {
    path: '/user/profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      allowedRoles: [Role.ADMIN, Role.USER]
    },
    children: [
      {
        path: '/user/profile/:userId/update',
        name: 'ProfileUpdateUser',
        components: { dialog: CreateOrUpdateUser },
        meta: {
          allowedRoles: [Role.ADMIN, Role.USER]
        }
      },
      {
        path: '/user/profile/devices/:deviceId/update',
        name: 'ProfileUpdateDevice',
        components: { dialog: UpdateDevice },
        meta: {
          allowedRoles: [Role.USER, Role.USER]
        }
      },
      {
        path: '/user/profile/devices/add',
        name: 'ProfileAddDevice',
        components: { dialog: AddDevice },
        meta: {
          allowedRoles: [Role.USER]
        }
      }
    ]
  },

  {
    path: '/credentials',
    name: 'Credentials',
    component: Credentials,
    meta: {
      allowedRoles: [Role.ADMIN, Role.USER]
    },
    children: [
      {
        path: '/credentials/:userId?/add',
        name: 'CreateCredential',
        components: { dialog: CreateOrUpdateCredential },
        meta: {
          allowedRoles: [Role.ADMIN, Role.USER]
        }
      },
      {
        path: '/credentials/:userId?/:credentialId/update',
        name: 'UpdateCredential',
        components: { dialog: CreateOrUpdateCredential },
        meta: {
          allowedRoles: [Role.ADMIN, Role.USER]
        }
      }
    ]
  },
  {
    path: '/credentials/:userId?/:credentialId/certificates',
    name: 'CredentialCertificates',
    component: CredentialCertificates,
    meta: {
      allowedRoles: [Role.ADMIN, Role.USER]
    }
  },
  {
    path: '/devices',
    name: 'Devices',
    component: Devices,
    meta: {
      allowedRoles: [Role.ADMIN]
    },
    children: [
      {
        path: '/devices/:deviceId/update',
        name: 'UpdateDevice',
        components: { dialog: UpdateDevice },
        meta: {
          allowedRoles: [Role.ADMIN]
        }
      },
      {
        path: '/devices/add',
        name: 'AddDevice',
        components: { dialog: AddDevice },
        meta: {
          allowedRoles: [Role.ADMIN]
        }
      }
    ]
  },
  {
    path: '/signature-background',
    name: 'SignatureBackground',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'signature-background'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/quantum-safe-demo',
    name: 'Quantum-safe Demo',
    async beforeEnter() {
      if (store.state.remoteConfig.rdssPublicUrl) {
        await rdssUtil.joinUserOnRdss()
        const rdssPublicUrl = store.state.remoteConfig !== null ? store.state.remoteConfig.rdssPublicUrl : ''
        location.href = rdssPublicUrl + 'quantum-safe-demo'
      }
    },
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/license',
    name: 'License',
    component: License,
    meta: {
      allowedRoles: [Role.ADMIN]
    }
  },
  {
    path: '/loginError',
    name: 'LoginError',
    component: LoginError,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/permissionDenied',
    name: 'PermissionDenied',
    component: PermissionDenied,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/notFound',
    name: 'NotFound',
    component: PermissionDenied,
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/logoutfromrdss'
  },
  {
    path: '/login-callback'
  },
  {
    path: '/logout'
  },
  {
    path: '*',
    redirect: 'NotFound'
  }
]

function createRouter(auth) {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  router.beforeEach(async (to, from, next) => {
    // console.log('rssp router beforeEach', to, from)
    if (to.path === '/login-callback') {
      let state = null
      try {
        state = await auth.handleLoginCallback()
        const currentUser = await users.joinUser()
        store.commit('setCurrentUser', currentUser)
        // console.debug('rssp login-callback state', state)
        // check that we are redirecting to a path or a named route
        const isStateString = typeof state === 'string' || state instanceof String
        // console.log('state type', typeof state)
        // console.log('isStateString', isStateString)
        // if (isStateString && state.includes('/')) {
        if (isStateString) {
          next({
            path: state,
            replace: true
          })
        } else {
          next({
            // name: state,
            name: state.name,
            replace: true
          })
        }
      } catch (error) {
        console.error('rssp logincallback exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    const user = await auth.getUser()
    // console.log('rssp user router, user', user)

    if (to.name === 'Welcome') {
      if (user) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }

      return
    }
    if (user) {
      const currentUser = await users.joinUser()
      store.commit('setCurrentUser', currentUser)

      const { allowedRoles } = to.meta

      if (allowedRoles) {
        let matchedRoles = []
        try {
          if (store.state.currentUser && store.state.currentUser.status !== 'SUSPENDED') {
            matchedRoles = store.state.currentUser.roles.filter(role => allowedRoles.includes(role))
          }
        } catch (error) {
          console.error(error)
          next({ name: 'PermissionDenied' })
          return
        }

        if (!matchedRoles.length) {
          next({ name: 'PermissionDenied' })
          return
        }
      }
    }

    if (to.path === '/logoutfromrdss') {
      try {
        // console.log('rssp router logoutfromrdss called')
        await auth.logoutAction(false)
        const rdssPublicUrl = store.state.remoteConfig && store.state.remoteConfig.rdssPublicUrl
        if ((rdssPublicUrl !== undefined) && (rdssPublicUrl.length > 0)) {
          const logouturl = rdssPublicUrl + 'logout'
          window.location.href = logouturl
        }
      } catch (error) {
        console.error('RSSP logout exception', error)
      }

      return
    }
    if (to.path === '/logout') {
      try {
        // console.log('rssp router logout called')
        await auth.logoutAction(false)
        if (store.state.remoteConfig.rdssPublicUrl) {
          next({ name: 'DashboardRDSS' })
        }
      } catch (error) {
        console.error('RSSP logout exception', error)
        next({ name: 'Welcome' })
      }

      return
    }

    /* if (!user) {
      auth.login(to.name || 'DashboardRDSS')

      return
    } */

    if (!user && to.name !== 'Welcome') {
      // next({ name: 'Welcome', query: { redirect: to.fullPath } })
      // console.debug("rssp user not defined, to isn't Welcome, doing login")
      await auth.login(to)
      return
    }

    next()
  })

  auth.addUserUnloaded(() => {
    router.push({ name: 'Welcome' })
  })

  return router
}

export default createRouter
